import { r as o } from "./browser-regex-BXD4sPCw.mjs";
const s = (r) => o.test(r), t = s;
export {
  t as i
};
//# sourceMappingURL=isBrowserSupported-mxEw7YQp.mjs.map
